export function getBrandPageUrl(appId, itemProperty) {
  const { vendor_name: vendorName } = itemProperty

  if (!vendorName) return

  switch (appId) {
    case 'a_kvjkW9ojzRneIkLxjVZ3r8dG':
    case 'a_7gVENerXpAyQHj6oaDypVPJZ': {
      const is1010Hope = appId === 'a_kvjkW9ojzRneIkLxjVZ3r8dG'
      const prefix = is1010Hope ? '/brand/' : '/brands/'
      const suffix = is1010Hope ? '.html' : ''
      return vendorName
        ? `${window.location.origin}${prefix}${vendorName
            .trim()
            .toLowerCase()
            .replaceAll(/&#[0-9]{1,};+/g, '')
            .replaceAll('10/10', '10-10')
            .replaceAll(' + ', '-')
            .replaceAll('+', '-')
            .replaceAll(' ', '-')
            .replaceAll('è', 'e')
            .replaceAll('ï', 'i')
            .replaceAll(/[^a-zA-Z0-9-]+/g, '')}${suffix}`
        : undefined
    }
    default:
      break
  }
}
